<template>
    <PlantConfigurationTeams :plantID="plantID"></PlantConfigurationTeams>
</template>

<script>
import PlantConfigurationTeams from '@/components/plants/configuration/PlantConfigurationTeams.vue';

export default {
    components: {
        PlantConfigurationTeams
    },
    data() {
        return {
            
        };
    },
    computed: {
        plantID() {
            return this.$route.params.plantID;
        }
    },
    methods: {

    },
    created() {
        
    }
}
</script>

<style>

</style>
